import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import classNames from 'classnames'
import Portal from '@mui/material/Portal'
import _ from 'lodash'
import queryString from 'query-string'
import styles from './app.module.css'
import AppToolbar from './AppToolbar'
import MessagesBar from './MessagesBar'
import ProgressDialog from './ProgressDialog'
import { closeMenu } from '../actions/mainMenuActions'
import { recuperarInformacoesContextoAplicacao } from '../actions/contextoAplicacaoActions'
import {
  iniciarResponsabilidadeUnidadeAtual,
  iniciarUnidadesAtuais
} from '../controllers/unidadesController'
import { atualizarFiltros } from '../actions/filtrosActions'
import { encerrarWebSocket, iniciarWebSocket } from '../controllers/alertasController'
import AutoRefreshToken from './AutoRefreshToken'
import MensagemTelaInicial from './mensagens/MensagemTelaInicial'

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      userMenuAnchorEl: null
    }
    this.redirect = this.redirect.bind(this)
    this.handleMainMenuClose = this.handleMainMenuClose.bind(this)
    this.handleUserMenuOpen = this.handleUserMenuOpen.bind(this)
    this.handleUserMenuClose = this.handleUserMenuClose.bind(this)
  }

  componentDidMount() {
    const {
      authentication,
      unidadesUsuario: { unidades }
    } = this.props
    if (authentication && authentication.isUserAuthenticated) {
      if (_.isNil(unidades)) {
        const { visao } = queryString.parse(this.props.location.search)
        this.props.recuperarInformacoesContextoAplicacao(!_.isNil(visao))
      }
      iniciarWebSocket()
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    this.initUnidadesAtuais(prevProps)
  }

  componentWillUnmount() {
    encerrarWebSocket()
  }

  initUnidadesAtuais(prevProps) {
    const {
      filtros: { unidadesAtuais },
      unidadesUsuario: { unidades, unidadeVinculacaoHierarquica }
    } = this.props
    const {
      unidadesUsuario: { unidades: prevUnidades }
    } = prevProps
    if (!_.size(prevUnidades) && _.size(unidades)) {
      const nextUnidadesAtuais = iniciarUnidadesAtuais(
        unidadesAtuais,
        unidades,
        unidadeVinculacaoHierarquica
      )
      const nextResponsabilidadeUnidadeAtual = iniciarResponsabilidadeUnidadeAtual()
      this.props.atualizarFiltros({
        unidadesAtuais: nextUnidadesAtuais,
        responsabilidadeUnidade: nextResponsabilidadeUnidadeAtual
      })
    }
  }

  redirect(path) {
    if (path) this.props.history.push(path)
  }

  handleUserMenuOpen(event) {
    this.setState({ userMenuAnchorEl: event.currentTarget })
  }

  handleUserMenuClose(path) {
    this.setState({ userMenuAnchorEl: null })
    this.redirect(path)
  }

  handleMainMenuClose(path) {
    this.props.closeMenu()
    this.redirect(path)
  }

  render() {
    const {
      children,
      noAppToolbar,
      mainMenu: { mainMenuOpen }
    } = this.props
    const { userMenuAnchorEl } = this.state
    return (
      <div className={styles.appFrame}>
        <AutoRefreshToken />
        {!noAppToolbar && (
          <AppToolbar
            handleMainMenuClose={this.handleMainMenuClose}
            userMenuAnchorEl={userMenuAnchorEl}
            handleUserMenuOpen={this.handleUserMenuOpen}
            handleUserMenuClose={this.handleUserMenuClose}
          />
        )}
        <main
          className={classNames(styles.content, {
            [styles.contentLeft]: !noAppToolbar,
            [styles.contentShift]: !noAppToolbar && mainMenuOpen,
            [styles.contentShiftLeft]: !noAppToolbar && mainMenuOpen
          })}>
          {!noAppToolbar && <div className={styles.drawerHeader} />}
          <MensagemTelaInicial />
          {children}
          <Portal>
            <MessagesBar />
          </Portal>
          <ProgressDialog />
        </main>
      </div>
    )
  }
}

const mapStateToProps = ({ mainMenu, authentication, filtros, unidadesUsuario }) => ({
  mainMenu,
  authentication,
  filtros,
  unidadesUsuario
})

const reduxEnhanced = connect(mapStateToProps, {
  closeMenu,
  recuperarInformacoesContextoAplicacao,
  atualizarFiltros
})(App)

export default withRouter(reduxEnhanced)
